import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassificationOffenseChartComponent } from './classification-offense-chart.component';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
import { ToastrModule } from 'ngx-toastr'; // Import ToastrModule if ToastrService is used

@NgModule({
  declarations: [
    ClassificationOffenseChartComponent // Declare the ClassificationOffenseChartComponent
  ],
  imports: [
    CommonModule,                  // Import necessary Angular modules
    ToastrModule.forRoot()         // Include ToastrModule if ToastrService is used
  ],
  providers: [
    ChartConfigService             // Provide the ChartConfigService for dependency injection
  ],
  exports: [
    ClassificationOffenseChartComponent // Export the ClassificationOffenseChartComponent for use in other modules
  ]
})
export class ClassificationOffenseChartModule { }
